import slick from '../libs/slick';
export default
    {

        init() {
            // JavaScript to be fired on all pages

            window.slick_product_carousel_config = {
                autoplay: false,
                dots: true,
                arrows: false,
                prevArrow: $('.container-product-carousel .slide-prev'),
                nextArrow: $('.container-product-carousel .slide-next'),
                adaptiveHeight: true,
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 3,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            adaptiveHeight: true,
                            dots: true,
                            arrows: false
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            adaptiveHeight: true,
                            dots: true,
                            arrows: false
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            adaptiveHeight: true,
                            dots: false,
                            arrows: true
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            adaptiveHeight: true,
                            dots: false,
                            arrows: true
                        }
                    }
                ]
            };
        },

        finalize() {
            // JavaScript to be fired on all pages, after page specific JS is fired
            let scrollpos;
            $('#hamburger').on('click', function () {
                console.log('hamburger click');
                if ($('body').attr('class') === undefined || $('body').attr('class').indexOf('hamburger-is-active') === -1) {
                    console.log('open layer');
                    scrollpos = $(window).scrollTop();
                    $('body').addClass('hamburger-is-active');
                    setTimeout(function () {
                        $('body').addClass('body-blocked');
                    }, 300);
                } else {
                    console.log('close layer');
                    $('body').removeClass('body-blocked');
                    $("body").removeClass('hamburger-is-active');
                    $('html, body').scrollTop(scrollpos);
                }
            });

            // MENU
            $(window).on('scroll', function () {
                let scroll = $(window).scrollTop();
                if (scroll > 300) {
                    $('header').addClass('collapsed');
                    $('#main-content').addClass('collapsed');
                }
                else {
                    if (scroll < 200) {
                        $('header').removeClass('collapsed');
                    }
                    if (scroll < 100) {
                        $('#main-content').removeClass('collapsed');
                    }
                }
            });

            // crea custom select option from category - subcategory
            var foundin = $('#lista_categorie option:contains("optgroup-")');
            console.log('route page');
            if (foundin.length > 0) {
                $.each(foundin, function (value) {
                    var updated = $(this).val().replace('optgroup-', '');
                    $(this).nextUntil('option:contains("endoptgroup")').wrapAll('<optgroup label="' + updated + '"></optgroup>');
                });
                $('#lista_categorie option:contains("optgroup-")').remove();
                $('#lista_categorie option:contains("endoptgroup")').remove();
            }

            if ($('.product-carousel').length > 0) {
                $('.product-carousel').slick(window.slick_product_carousel_config);
            }

            slick();
        },
    };



// WEBPACK FOOTER //
// ./scripts/routes/common.js